import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, RedirectCommand } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserService } from "../../data/user/user.service";

@Injectable({ providedIn: 'root' })
export class UserResolver implements Resolve<any | RedirectCommand> {
  constructor(private userService: UserService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any | RedirectCommand> | Promise<any | RedirectCommand> | any | RedirectCommand {
    return this.userService.getCurrentUserProfile();
  }
}
